// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#344E41","preview":"Preview_preview__h8zV0","title":"Preview_title__PSeH2","cards":"Preview_cards__aBRCD"};